import { memo } from 'radash';

export const isDomain = memo((value = ''): boolean => {
  if (!value) return false;

  return new RegExp(/^(?!-)[A-Za-z0-9-]+([-.]{1}[a-z0-9]+)*\.[A-Za-z]{2,6}$/).test(value);
});
